// extracted by mini-css-extract-plugin
module.exports = {"tagCloud":"index_tagCloud-3UY18"};